// extracted by mini-css-extract-plugin
export default {"OfflineBanner_container":"OfflineBanner_container_nVYKG_v17-8-1","OfflineBanner_text":"OfflineBanner_text_QLMlC_v17-8-1"};